import "../../styles/uniBadge.css";

export default function UniBadge({country, name, emblem}: any) {
    return <>
        <div className="unibadgecontainer">
            <img src={emblem} alt="" className="emblem" />
            <div className="infocontainer">
                <div className="country">{country}</div>
                <div className="name">{name}</div>
            </div>
        </div>
    </>;
};